const LeftTrapeze = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="400"
    height="120"
    fill="none"
    viewBox="0 0 456 120"
  >
    <path fill="#E42436" d="M-19-8h475L344.023 163H-19z"></path>
  </svg>
);

export default LeftTrapeze;
